import React, { useEffect, useState } from "react";

import "./dashboard.css";
import { useSelector } from "react-redux";
import { getCompany, getUserName } from "../../../Redux/selecters";
import ApiService from "../../services/apiService";

const DashBoard = () => {
    const apiService = new ApiService();
    const Name = useSelector(getUserName);
    const companies = useSelector(getCompany);
    
    // useEffect(() => {
    //     const storedPermissions = JSON.parse(localStorage.getItem('RoleAccess')) || [];
    //     if(storedPermissions?.length === 0){
    //         handleDBChange()
    //     }
    // }, [companies]);
    
    const handleDBChange = async () => {
        let param = `?username=${Name}&companyNo=${companies?.selectedCompany?.companyNo}`
        const res = await apiService.getApiParamater("GET_PERMISSIONS", param);
        const permissions = res?.data?.data.filter((per) => per.moduleName === "Procurement");
        
        localStorage.setItem('RoleAccess', JSON.stringify(permissions));
        window.location.reload();
    };
    return (
        <div className="p-4">
        </div>
    );
};

export default DashBoard;
